import { render, staticRenderFns } from "./Reconciliation.vue?vue&type=template&id=56bf0890"
import script from "./Reconciliation.vue?vue&type=script&lang=js"
export * from "./Reconciliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports